import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useMemo, useState } from 'react';

import AutoComplete from 'components/field/AutoComplete';
import Button from 'components/field/Button';
import IntegerInput from 'components/field/IntegerInput';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import Table from 'components/table/Table';

import { AUTOCOMPLETE } from 'services/consts';

const PartialPutModal = NiceModal.create(
	({ insert, id, setValue, sku, productID, quantity, fromLocationID, index }) => {
		const modal = useModal();
		const [qtyPut, setQtyPut] = useState();
		const [binLocationID, setBinLocationID] = useState();

		const productAutocompleteColumns = useMemo(() => [{ accessor: 'name', width: 200 }], []);
		const responsibleAutocompleteColumns = useMemo(() => [{ accessor: 'Name', width: 200 }], []);

		const tableColumns = useMemo(
			() => [
				{
					id: 'sku',
					header: 'productName',
					size: 150,
					renderCell: ({ row }) => (
						<AutoComplete
							autoCompleteName={AUTOCOMPLETE.PRODUCTS}
							value={row.original.productID}
							columns={productAutocompleteColumns}
							selectionLabelAccessor={['name', 'SKU']}
							viewMode
						/>
					)
				},
				{
					id: 'qtyPut',
					header: 'qtyPut',
					size: 150,
					renderCell: ({ row }) => (
						<IntegerInput
							value={row.original.qtyPut}
							setValue={(value) => {
								if (quantity < value) return;
								setQtyPut(value);
							}}
							maxPlaceholder={quantity}
							max={quantity}
							showArrows={false}
						/>
					)
				},
				{
					id: 'binLocation',
					header: 'binLocation',
					size: 150,
					renderCell: ({ row }) => (
						<AutoComplete
							autoCompleteName={AUTOCOMPLETE.PUT_AND_PICK_BINS_BY_BIN_ID}
							columns={responsibleAutocompleteColumns}
							value={row.original.binLocationID}
							setValue={(value, firstRender) => {
								if (firstRender) return;
								setBinLocationID(value?.ID ?? null);
							}}
							selectionLabelAccessor={['Name']}
							filterObject={{
								binID: fromLocationID
							}}
						/>
					)
				}
			],
			[]
		);

		const handleSubmit = () => {
			setValue(`orderItems[${index}].quantity`, quantity - qtyPut, {
				shouldDirty: true,
				shouldValidate: true
			});
			insert(index + 1, {
				sku,
				productID,
				quantity: qtyPut,
				qtyPut,
				binLocationID,
				id,
				locked: true
			});
			modal.remove();
		};

		return (
			<Modal>
				<ModalTitle>
					<Typography variant="p1">partialPut</Typography>
				</ModalTitle>
				<ModalContent>
					<Table columns={tableColumns} data={[{ productID, qtyPut, quantity, binLocationID }]} />
				</ModalContent>
				<ModalActions>
					<Button label="cancel" variant="outline" onClick={() => modal.remove()} />
					<Button
						label="partialPut"
						disabled={!qtyPut || !binLocationID}
						disabledTooltip={(!qtyPut || !binLocationID) && 'formInfo.noChanges'}
						onClick={handleSubmit}
					/>
				</ModalActions>
			</Modal>
		);
	}
);

export default PartialPutModal;
